/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { CompanyType } from './company-type.model';
import { AddressDTO } from "@well/address-management-domain-model";
import { LegalEntityVo } from './legal-entity-vo';

export class LegalEntityModel extends JSONable {
  companyRegistrationUuid: string | null = null;
  publicBusinessProfileUuid: string | null = null;
  uuid: string | null = null;
  companyName: string | null = null;
  uniqueIdNumber: string | null = null;
  registrationCode: string | null = null;
  country: string | null = null;
  financialAddressDTO: AddressDTO | null = null;
  officeAddressDTO: AddressDTO | null = null;
  mainAddress: string | null = null;
  mainPhone: string | null = null;
  mainEmailAddress: string | null = null;
  industryTypeValue: string | null = null;
  preferredLanguage: string | null = null;
  emailImportSettings: string | null = null;
  vatRegistration: boolean | null = null;
  vatSplitStatus: boolean | null = null;
  vatInactiveStatus: boolean | null = null;
  vatInactivationDate: string | null = null;
  globalAccountCode: string | null = null;
  globalAccountTypeValue: string | null = null;
  serviceProviderUuid: string | null = null;
  vat: string | null = null;
  validated: boolean | null = null;
  companyType: CompanyType | null = null;

  // meta
  origin: 'LOCAL' | 'ANAF' | 'COFACE' | null = null;

  static isInPlatform(legalEntity: LegalEntityModel | null): boolean{
    return legalEntity?.companyType != null;
  }

  static mapToVo(legalEntity: LegalEntityModel): LegalEntityVo {

    const legalEntityVo = new LegalEntityVo();
    legalEntityVo.uuid = legalEntity.uuid || '';
    legalEntityVo.uniqueIdentificationNumber = legalEntity.uniqueIdNumber || '';
    legalEntityVo.country = legalEntity.country || '';
    legalEntityVo.companyName = legalEntity.companyName || '';
    legalEntityVo.industryType = legalEntity.industryTypeValue || '';

    return legalEntityVo;
  }
}
